<template>
  <div>
    <h3 class="mb-5">Messaging & Highlight</h3>
    <div class="h4 mb-5">
      呈現於Product Sub Category Page (Product Overview)
      置頂Banner區，可自行添加Banner數量。
    </div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in itemList" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Banner {{ i + 1 }}</h3>
      </template>
      <template v-slot:body>
        <!-- PageTitle -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">PageTitle</h4>
          <div class="flex-grow-1 pt-5">
            {{ item.pageTitle }}
          </div>
        </label>

        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Visual</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <div
              class="w-280px h-180px bg-cover bg-center"
              :style="{ 'background-image': `url(${item.visual})` }"
            ></div>
          </div>
        </div>
      </template>
    </PageCollapse>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  components: {
    PageCollapse,
  },
  data: () => ({
    itemList: [
      {
        id: '001',
        pageTitle: 'item1',
        visual: 'https://dummyimage.com/280x180.jpg',
      },
      {
        id: '002',
        pageTitle: 'item2',
        visual: 'https://dummyimage.com/280x180.jpg',
      },
      {
        id: '003',
        pageTitle: 'item3',
        visual: 'https://dummyimage.com/280x180.jpg',
      },
    ],
  }),
};
</script>

<style></style>
